import search from "../../../src/images/search.svg";
import React, { useEffect, useState } from "react";
import { INCUBATOR_PREFRENCE_LIST, INCUBATOR_PREFRENCE_LIST_POST } from "../../constants/api";
import { post } from "../../effects/api/api.common";
import { getSessionStorageValue } from "../../effects/utils/session-storage";
import { filterByValue } from "../../utils/CommonMethods";
import { BsFillEyeFill } from "react-icons/bs";
import { Modal } from "react-bootstrap";
import IncubatorPrefrenceInformationComponent from "./IncubatorPrefrenceInformationComponent";



export default function IncubatorPreferenceComponent() {
  const [showReport, setShowReport] = useState(false);
  const [getIncuberId, setIncuberId] = useState();
  const [getAppId, setAppId] = useState();
  const [getUserName, setUserName] = useState();
  const [incubatorList, setIncubatorList] = useState([]);
  const [filteredIncubatorList, setFilteredIncubatorList] = useState<any>([]);
  const [noDataFilter, setNoDataFilter] = useState('');
  const [loggedInRole, setLoggedInRole] = useState('');
  const [showToEac, setShowToEac] = useState(false);
  const [activeIndex, setActiveIndex] = useState("grievances");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (getSessionStorageValue("user")) {
      const user: any = getSessionStorageValue("user");
      const userInfo = JSON.parse(user)
      setLoggedInRole(userInfo.roles);
      if (userInfo.roles === 'dpiit') {
        setShowToEac(false);
      }
      else if (userInfo.roles === 'secretariat') {
        setShowToEac(false);
      }
    }
    getUserList();
  }, []);

  const changeActive = (tabs: any) => {
    setActiveIndex(tabs)
  }

  const getUserList = () => {
    post(INCUBATOR_PREFRENCE_LIST, '').then((response: any) => {
      if (!response || !response.data) return;
      setIncubatorList(response.data.data)
      // console.log(response.data.data);
    });
  };

  const searchList = (e: any) => {
    setNoDataFilter(e.target.value)
    const filteredData = filterByValue(incubatorList, e.target.value);
    setFilteredIncubatorList(filteredData)
  }

  const handleAllCheck = (e: any, id: any, id1: any,application_type :any) => {
    var isChecked = e.target.checked;
    if (isChecked) {
      const payload = {
        "active_status": "1",
        "incubator_application_id": id,
        "incubator_id": id1,
        "application_type":application_type 
      }
      // return;
      post(INCUBATOR_PREFRENCE_LIST_POST, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.result === "success") {
          getUserList()
          if(filteredIncubatorList.length!=0){
            let index=filteredIncubatorList.findIndex((p:any) => p.incubator_id == id1);
            filteredIncubatorList[index].active_status='0'
            setFilteredIncubatorList(filteredIncubatorList)
          }
        }
      });
    } else if (isChecked == false) {
      const payload = {
        "active_status": "0",
        "incubator_application_id": id,
        "incubator_id": id1,
        "application_type":application_type 
      }
      post(INCUBATOR_PREFRENCE_LIST_POST, payload).then((response: any) => {
        if (!response || !response.data) return;
        if (response.data.result == "success") {
          getUserList()
          if(filteredIncubatorList.length!=0){
            let index=filteredIncubatorList.findIndex((p:any) => p.incubator_id == id1);            
            filteredIncubatorList[index].active_status='1'
            setFilteredIncubatorList(filteredIncubatorList)
          }
        }
      });
    }
  };

  const getVal = (id: any, appId: any, userName: any) => {
    setAppId(appId);
    setIncuberId(id);
    setUserName(userName);
  }

  return (
    <>
      <div className="app-inside app-apply-incubator">
        <div className="status-list-wrapper mt-4">
          <div className="container">

            <div className=" text-right">
              <div className="d-flex searchDiv align-self-end mt-3 justify-content-end">
                <div className="d-flex searchDiv align-self-end mr-3 mt-3">
                  <img src={search} className="search" alt="search" />
                  <input className="searchBar" type="text" placeholder="Search.." name="search" onKeyUp={searchList} />
                </div>
              </div>
            </div>

            <div className="app-inside-content">
              <div className="tab-pane active" id="tabs-1">
                <div className="table-scroll mb-4">
                  <table className="reviewTable userListTable" >
                    <thead>
                      <tr>
                        <th className="text-left table-heading custom-td-left table-heading ">Incubator <br /> Application ID</th>
                        <th className="text-left table-heading">Incubator <br /> Name</th>
                        <th className="text-left table-heading">Active<br/></th>
                        <th className="text-left table-heading">Incubator <br /> Logs</th>
                      </tr>
                    </thead>

                    <tbody>
                      {incubatorList.length === 0 || (filteredIncubatorList.length === 0 && noDataFilter !== '') ? <tr><td className="text-center" colSpan={5}>No data</td></tr> :
                        (filteredIncubatorList.length == 0 ?
                          incubatorList.map((item: any, id: any) => (
                            <tr key={id}>
                              <td className="text-left custom-td">{item.incubator_application_no == null ||'' ? item.incubator_application_id : item.incubator_application_no}</td>
                              <td className="text-left custom-td">{item.registered_name}</td>

                              <td className="text-center custom-td slider-td">
                                <label className="switch">
                                  <input type="checkbox" checked={item.active_status == 0 ? false : true} onChange={(e: any) => handleAllCheck(e, item.incubator_application_id, item.incubator_id,item.application_type)} />
                                  <span className="slider round"></span>
                                </label>
                              </td>
                              <td>{ }
                                <BsFillEyeFill onClick={() => { setShowReport(true); getVal(item.incubator_id, item.incubator_application_id, item.incubator_name) }} />
                              </td>
                            </tr>
                          )) :
                          filteredIncubatorList.map((item: any, id: any) => (
                            <tr key={id}>
                              <td className="text-left custom-td">{item.incubator_application_no == null ||'' ? item.incubator_application_id : item.incubator_application_no}</td>
                              <td className="text-left custom-td">{item.registered_name}</td>

                              <td className="text-center custom-td slider-td">
                                <label className="switch">
                                  <input type="checkbox" checked={item.active_status == '0' ? true : false} onChange={(e: any) => handleAllCheck(e, item.incubator_application_id, item.incubator_id,item.application_type)} />
                                  <span className="slider round"></span>
                                </label>
                              </td>
                              <td>
                                <BsFillEyeFill onClick={() => { setShowReport(true); getVal(item.incubator_id, item.incubator_application_id, item.incubator_name) }} />
                              </td>
                            </tr>
                          ))
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <Modal
            show={showReport}
            onHide={() => setShowReport(false)}
            dialogClassName="modal-lg modal-dialog-scrollable  table-hover"
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Header >
              <Modal.Title id="example-custom-modal-styling-title text-center">
                Incubator Information
              </Modal.Title>
                <button type="button" onClick={() => setShowReport(false)} className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>

            <Modal.Body>
              <IncubatorPrefrenceInformationComponent incubatorId={getIncuberId} appId={getAppId} userName={getUserName} />
            </Modal.Body>
{/* 
            <div className=" schedule-button-pd text-right pr-3 buttonCss">
              <button
                className="btn btn-sisfs btn-yellow-primary"
                data-toggle="modal"
                data-target="#scheduleMeeting"
                onClick={() => setShowReport(false)}
              >
                Close
              </button>
            </div> */}
          </Modal>
        </div>
      </div>
    </>
  )
}
